export default "__VITE_ASSET__b8b9d971__"